import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Awards.css";

import awardarc1 from "../assets/Best Supplier – Six sigma project Award - Cummins.jpg";
import awardarc2 from "../assets/Best Process and System Award - Hanon.jpg";
import awardarc3 from "../assets/Best in Quality Award - Daimler.jpg";
import awardarc4 from "../assets/Best Performer in Production Support category - Hyundai.jpg";
import awardarc5 from "../assets/Supplier of the year award for cost management - Paccar.jpg";
import awardarc6 from "../assets/Category partner – Aluminum castings Award - Cummins.jpg";
import awardarc7 from "../assets/Product Dev. Support Excellence Award - Cummins India.JPG";
import awardarc8 from "../assets/Disaster management Award - Hyundai.JPG";
import awardarc9 from "../assets/Best Supplier Award - Rotex Automation.JPG";
import awardarc10 from "../assets/Best Crisis Management Support Award - Hanon.JPG";
import awardarc11 from "../assets/2016 -  Supplier of the year Award - Paccar.jpg";
import awardarc12 from "../assets/Special award for globally competitive supplies - Daimler.jpg";
import awardarc13 from "../assets/Best supplier six sigma project award - Cummins.jpg";
import awardarc14 from "../assets/Appreciation award – Hyundai.jpg";
import awardarc15 from "../assets/Superior quality award - Cummins.jpg";
import awardarc16 from "../assets/Project Management Excellence Award - Cummins India ABO.jpg";
import awardarc17 from "../assets/Continuous improvement appreciation for Zero Defect - Cummins.jpg";
import awardarc18 from "../assets/Best cost sourcing event – ZF.jpg";

// 2013 -> 2006
import awardarc19 from "../assets/Excellence In Delivery Award - Delphi - TVS Diesel Systems Ltd.jpg";
import awardarc20 from "../assets/Bronze Award for Cost category - Honda.jpg";
import awardarc21 from "../assets/Merit Award for Best Cooperation - Hyundai.jpg";
import awardarc22 from "../assets/Excellent Performance Award for Machined castings - Cummins.jpg";
import awardarc23 from "../assets/Appreciation Award – Best India Supplier in the category of Delivery, Quality & NPD - Hyundai.jpg";
import awardarc24 from "../assets/Appreciation award - Hyundai.jpg";
import awardarc25 from "../assets/Appreciation award for Six sigma Initiatives - Cummins.jpg";
import awardarc26 from "../assets/Excellent performance award - Cummins.jpg";
import awardarc27 from "../assets/New product introduction - Wabco.jpg";
import awardarc28 from "../assets/Enduring relationship - Wabco.jpg";
import awardarc29 from "../assets/Excellent performance in Six sigma initiatives - Cummins, US.jpg";
import awardarc30 from "../assets/Best Supplier award for Cost reduction - Honda.jpg";
import awardarc31 from "../assets/Most Improved Supplier award - Cummins, US.jpg";
import awardarc32 from "../assets/Best supplier award for Responsiveness - Cummins ABO.jpg";
import awardarc33 from "../assets/100% defect free delivery for Q2, Q3 and Q4 - Cummins, US.jpg";
import awardarc34 from "../assets/Gold Award - The Economic times India Manufacturing Excellence Award.jpg";

import Footer from "./Footer";

// Archived awards - 2019 -> 2006
const allLogos = {
  "Customer Awards": [
    {
      img: awardarc1,
      alt: "Awards",
      caption: "2019 – Best Supplier – Six Sigma Project, Cummins",
    },
    {
      img: awardarc2,
      alt: "Awards",
      caption: "2019 – Best Process & System Award, Hanon",
    },
    {
      img: awardarc3,
      alt: "Awards",
      caption: "2019 – Best in Quality Award, Daimler",
    },
    {
      img: awardarc4,
      alt: "Awards",
      caption: "2018 – Best Performer in Production Support Category, Hyundai",
    },
    {
      img: awardarc5,
      alt: "Awards",
      caption: "2017 – Supplier of the Year Award for Cost Management, Paccar",
    },
    {
      img: awardarc6,
      alt: "Awards",
      caption: "2017 – Category Partner – Aluminium Castings Award, Cummins",
    },
    {
      img: awardarc7,
      alt: "Awards",
      caption: "2016 – Product Dev. Support Excellence Award, Cummins India",
    },
    {
      img: awardarc8,
      alt: "Awards",
      caption: "2016 – Disaster Management Award, Hyundai",
    },
    {
      img: awardarc9,
      alt: "Awards",
      caption: "2016 – Best Supplier Award, Rotex Automation",
    },
    {
      img: awardarc10,
      alt: "Awards",
      caption: "2016 – Best Crisis Management Support Award, Hanon",
    },
    {
      img: awardarc11,
      alt: "Awards",
      caption: "2016 – Supplier of the Year Award, Paccar",
    },
    {
      img: awardarc12,
      alt: "Awards",
      caption:
        "2015 – Special Award for Globally Competitive Suppliers, Daimler",
    },
    {
      img: awardarc13,
      alt: "Awards",
      caption: "2015 – Best Supplier Six Sigma Project Award, Cummins",
    },
    {
      img: awardarc14,
      alt: "Awards",
      caption: "2015 – Appreciation Award, Hyundai",
    },
    {
      img: awardarc15,
      alt: "Awards",
      caption: "2014 – Superior Quality Award, Cummins",
    },
    {
      img: awardarc16,
      alt: "Awards",
      caption:
        "2014 – Project Management Excellence Award, Cummins India ABO",
    },
    {
      img: awardarc17,
      alt: "Awards",
      caption:
        "2014 – Continuous Improvement Appreciation for Zero Defect, Cummins",
    },
    {
      img: awardarc18,
      alt: "Awards",
      caption: "2014 – Best Cost Sourcing Event, ZF",
    },
    {
      img: awardarc19,
      alt: "Awards",
      caption:
        "2013 – Excellence in Delivery Award, Delphi - TVS Diesel Systems Ltd",
    },
    {
      img: awardarc20,
      alt: "Awards",
      caption: "2012 – Bronze Award for Cost Category, Honda",
    },
    {
      img: awardarc21,
      alt: "Awards",
      caption: "2012 – Merit Award for Best Cooperation, Hyundai",
    },
    {
      img: awardarc22,
      alt: "Awards",
      caption:
        "2011 – Excellent Performance Award for Machined Castings, Cummins",
    },
    {
      img: awardarc23,
      alt: "Awards",
      caption:
        "2010 – Appreciation Award – Best India Supplier in the category of Delivery, Quality & NPD, Hyundai",
    },
    {
      img: awardarc24,
      alt: "Awards",
      caption: "2010 – Appreciation Award, Hyundai",
    },
    {
      img: awardarc25,
      alt: "Awards",
      caption:
        "2010 – Appreciation Award for Six Sigma Initiatives, Cummins",
    },
    {
      img: awardarc26,
      alt: "Awards",
      caption: "2010 – Excellent Performance Award, Cummins",
    },

   
    {
      img: awardarc34,
      alt: "Awards",
      caption:
        "2010 – Gold Award – The Economic Times India Manufacturing Excellence Award",
    },

    {
      img: awardarc27,
      alt: "Awards",
      caption: "2010 – New Product Introduction, Wabco",
    },
    {
      img: awardarc28,
      alt: "Awards",
      caption: "2009 – Enduring Relationship, Wabco",
    },
    {
      img: awardarc29,
      alt: "Awards",
      caption:
        "2009 – Excellent Performance in Six Sigma Initiatives, Cummins US",
    },
    {
      img: awardarc30,
      alt: "Awards",
      caption: "2008 – Best Supplier Award for Cost Reduction, Honda",
    },
    {
      img: awardarc31,
      alt: "Awards",
      caption: "2007 – Most Improved Supplier Award, Cummins US",
    },
    {
      img: awardarc32,
      alt: "Awards",
      caption: "2007 – Best Supplier Award for Responsiveness, Cummins ABO",
    },
    {
      img: awardarc33,
      alt: "Awards",
      caption:
        "2006 – 100% Defect Free Delivery for Q2, Q3 and Q4, Cummins US",
    },
  ],

  "External Awards": [],
};

export default function AwardsArchive() {
  const [activeTab, setActiveTab] = useState("Customer Awards");

  const list = allLogos[activeTab];

  return (
    <section id="awards-archive">
      <div className="customers-section-a">
        <Link to="/awards" className="award-back-link">
          ← Back to Awards
        </Link>

        <h2>Awards Photo Archive</h2>

        <div className="cust-underline-a"></div>

        <div className="tab-buttons-a">
          {Object.keys(allLogos).map((tab) => (
            <button
              key={tab}
              className={activeTab === tab ? "active" : ""}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="logo-grid-a">
          {list.length > 0 ? (
            list.map((logo, index) => (
              <div className="logo-card-a" key={index}>
                <div className="award-img-box">
                  <img src={logo.img} alt={logo.alt} />
                </div>

                {logo.caption && (
                  <p className="award-caption">{logo.caption}</p>
                )}
              </div>
            ))
          ) : (
            <p
              style={{
                gridColumn: "1 / -1",
                textAlign: "center",
                color: "#555",
              }}
            >
              No archived awards yet.
            </p>
          )}
        </div>
      </div>

      <Footer />
    </section>
  );
}